import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
  MatExpansionPanelActionRow
} from '@angular/material/expansion';

import { PortalModule } from '@angular/cdk/portal';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { MatIconModule, MatDialogModule } from '@angular/material';



@NgModule({
  declarations: [
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatExpansionPanelActionRow
  ],
  imports: [
    CommonModule,
    PortalModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    MatIconModule,
    MatDialogModule
  ],
  exports: [
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatExpansionPanelActionRow
  ]
})
export class MaterialModule { }
